import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitovapicab() {



  const cardData =
  {
    keyword: 'Mumbai to Vapi Cab ',
    heading: 'Shambhu Cabs: Mumbai to Vapi Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Vapi Cab services, providing safe, comfortable, and hassle-free travel for families, business travelers, corporate groups, and long-distance commuters heading to Vapi. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and pleasant journey from Mumbai to Vapi with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Vapi cab services for travelers seeking comfort, safety, punctuality, and a dependable travel experience.',

    top: 'Top Places to Visit in Vapi with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Daman Ganga Riverfront",
    "description": "The Daman Ganga Riverfront is one of the most peaceful and beautifully developed areas near Vapi, offering landscaped walkways, river views, and open recreational spaces. Visitors enjoy evening strolls along the wide promenade lined with benches, gardens, and decorative lighting. The gentle flow of the river, combined with the distant views of heritage structures in Daman, makes the riverfront a relaxing escape from the city’s industrial atmosphere. It is a popular spot for photography, family outings, and enjoying cool breezes."
  },
  {
    "title": "Jampore Beach (near Vapi)",
    "description": "Located only a short drive from Vapi, Jampore Beach is known for its clean shore, shallow waters, and peaceful atmosphere. The beach is ideal for swimming, leisurely walks, and relaxation under the shade of Casuarina trees. Adventure lovers can enjoy camel rides, horseback riding, and occasional beach sports. The beachside food shacks serve tasty seafood snacks, chai, and local delicacies. Its calm environment and scenic coastline make it one of the most preferred getaways for Vapi residents and visitors."
  },
  {
    "title": "Devka Beach (near Vapi)",
    "description": "Devka Beach, situated close to Vapi, is a scenic location featuring black volcanic rocks, breezy coastal winds, and a long promenade perfect for evening strolls. The amusement park, musical fountains, and food stalls add to the lively atmosphere. Though the rocky seabed limits swimming, the dramatic sunset views and open beach area attract families, couples, and photography enthusiasts. Devka Beach combines natural charm with entertainment, making it a popular outing spot."
  },
  {
    "title": "Silvassa Vasona Lion Safari (near Vapi)",
    "description": "Located in the nearby Union Territory of Dadra & Nagar Haveli, the Vasona Lion Safari offers visitors a thrilling wildlife experience within a protected forest zone. Tourists board secure safari buses that take them through natural habitats where Asiatic lions roam freely. The safari is perfect for wildlife enthusiasts, students, and families looking to experience nature up close. Surrounded by dense greenery and serene landscapes, the safari park is an exciting educational attraction near Vapi."
  },
  {
    "title": "Silvassa Tribal Museum",
    "description": "The Silvassa Tribal Museum showcases the culture, traditions, and lifestyle of the local tribes such as the Warli, Dhodia, and Kokna. The museum displays traditional tools, musical instruments, household objects, masks, and tribal artwork, offering a fascinating look into the region’s indigenous heritage. The carefully curated exhibits and realistic models help visitors understand centuries-old tribal customs, making it an enriching stop for culture lovers near Vapi."
  },
  {
    "title": "Dadra Garden",
    "description": "Dadra Garden, located near Silvassa and easily accessible from Vapi, is a beautifully landscaped park featuring lush greenery, fountains, and walking paths. The tranquil environment attracts morning walkers, families, and tourists seeking a peaceful retreat. Its clean surroundings, well-maintained lawns, and scenic water bodies make it an ideal destination for relaxation, picnics, and nature photography. The garden’s vibrant greenery offers a refreshing break from the city’s industrial zones."
  },
  {
    "title": "Satmaliya Deer Park",
    "description": "Satmaliya Deer Park is a serene wildlife reserve near Vapi, home to several species including spotted deer, nilgai, peacocks, and a variety of birds. Visitors can stroll along the pathways or enjoy guided tours to explore the natural ecosystem. The watchtower inside the park offers sweeping views of the surrounding forests and Madhuban Dam. Satmaliya is perfect for nature lovers, wildlife photographers, and families looking for a calm outdoor experience."
  },
  {
    "title": "Madhuban Dam",
    "description": "Madhuban Dam, built on the Daman Ganga River, is a popular recreational spot near Vapi surrounded by lush greenery and rolling hills. The reservoir creates a scenic waterbody perfect for sightseeing, picnics, and photography. The area is peaceful, offering a chance to unwind amid nature’s beauty. During monsoons, the dam becomes especially vibrant, with misty hill views and cool breeze making it an unforgettable experience for visitors."
  },
  {
    "title": "Hirwa Van Garden",
    "description": "Hirwa Van Garden, located in Silvassa near Vapi, is a well-developed garden known for its landscaped lawns, cascading waterfalls, and colorful flower beds. Built on a hilly terrain, the garden features rock pathways, viewing points, play areas, and scenic corners ideal for families and couples. The natural greenery combined with man-made elements makes it one of the most relaxing and photogenic attractions in the region."
  },
  {
    "title": "Our Lady of Remedios Church (near Vapi)",
    "description": "Our Lady of Remedios Church, located in Daman near Vapi, is a beautiful Portuguese-era church known for its intricate architecture and peaceful ambiance. The church’s elegant façade, stained-glass windows, and richly crafted interiors make it a significant heritage and spiritual landmark. Visitors appreciate the serene environment and the historical charm of the church, which continues to serve as an important place of worship for the local Christian community."
  }
],




"services": [
  {
    "name": "Mumbai Vapi Taxi",
    "description": "Mumbai Vapi Taxi provides reliable, comfortable, and safe intercity travel between Mumbai and Vapi. Perfect for business travelers, family trips, weekend plans, and industrial visits, the service ensures clean vehicles, experienced chauffeurs, and smooth highway travel via NH48. With flexible scheduling, timely pickups, and well-planned routes, passengers enjoy a stress-free long-distance journey from Mumbai to Vapi."
  },
  {
    "name": "Vapi Cab from Mumbai",
    "description": "Vapi Cab from Mumbai offers convenient door-to-door transportation for travelers heading to Vapi’s industrial zones, corporate offices, hotels, and residential areas. With multiple vehicle options and professional drivers familiar with the Mumbai–Vapi highway, this service is ideal for corporate travel, business meetings, factory visits, and personal trips to Vapi."
  },
  {
    "name": "One-Way Cab Mumbai Vapi",
    "description": "One-Way Cab Mumbai Vapi provides affordable and convenient single-direction travel for those who do not require a return journey. This service is perfect for business travelers, tourists, and students relocating to Vapi. With no hidden charges, instant confirmation, and multiple cab types, it ensures a smooth and budget-friendly one-way trip."
  },
  {
    "name": "Affordable Cab Mumbai Vapi",
    "description": "Affordable Cab Mumbai Vapi delivers cost-effective intercity travel solutions without compromising comfort or safety. This option is popular with frequent travelers, families, and individuals seeking economical transportation. Fuel-efficient vehicles, transparent pricing, and courteous drivers make it a highly reliable and budget-friendly travel choice."
  },
  {
    "name": "Best Taxi Mumbai Vapi",
    "description": "Best Taxi Mumbai Vapi offers premium-quality service with well-maintained vehicles, skilled drivers, and punctual pickups. It is ideal for passengers looking for the most reliable and comfortable travel experience to Vapi. Whether for corporate meetings, leisure trips, or family visits, the service ensures smooth, timely, and pleasant long-distance travel."
  },
  {
    "name": "SUV Cab Mumbai Vapi",
    "description": "SUV Cab Mumbai Vapi provides spacious and powerful SUVs equipped for safe and comfortable highway travel. Ideal for groups, families, and travelers carrying additional luggage, these vehicles deliver a smooth driving experience, extra legroom, and superior stability on long journeys between Mumbai and Vapi."
  },
  {
    "name": "Sedan Cab Mumbai Vapi",
    "description": "Sedan Cab Mumbai Vapi offers comfortable, stylish, and economical sedans suitable for individuals and small families. With smooth suspension, excellent mileage, and comfortable seating, sedans are a perfect choice for long-distance intercity travel, providing a balanced combination of affordability and comfort."
  },
  {
    "name": "Outstation Cab Mumbai Vapi",
    "description": "Outstation Cab Mumbai Vapi is tailored for long-distance travel needs, offering one-way, round-trip, and multi-day cab options. With dependable chauffeurs, well-serviced vehicles, and flexible travel timings, this service is ideal for work-related visits, family trips, vacations, and extended stays in Vapi and surrounding areas."
  },
  {
    "name": "24×7 Mumbai Vapi Taxi",
    "description": "24×7 Mumbai Vapi Taxi ensures round-the-clock availability for early morning departures, late-night travel, emergency trips, and airport pickups. With instant confirmations, safe highway driving, and reliable service at any hour, it is the ideal choice for travelers needing flexible scheduling and dependable transportation."
  },
  {
    "name": "Corporate Cab Mumbai Vapi",
    "description": "Corporate Cab Mumbai Vapi provides professional, punctual, and high-quality transport solutions tailored for business travelers. Equipped with clean luxury sedans and premium SUVs driven by trained chauffeurs, this service ensures a smooth and elegant travel experience for meetings, factory visits, and corporate tours in Vapi."
  },
  {
    "name": "Fast Cab Mumbai Vapi",
    "description": "Fast Cab Mumbai Vapi offers quick pickups, fast booking confirmation, and optimized highway routes to ensure passengers reach Vapi on time. Perfect for urgent travel needs, last-minute schedules, and time-sensitive plans, the service prioritizes speed, comfort, and reliability throughout the journey."
  },
  {
    "name": "Premium Cab Mumbai Vapi",
    "description": "Premium Cab Mumbai Vapi provides luxury-class travel with high-end vehicles, VIP-standard service, and professionally trained chauffeurs. Ideal for executive travel, special occasions, and travelers seeking maximum comfort, this service enhances the journey with upscale seating, smooth rides, and superior hospitality."
  },
  {
    "name": "Safe Cab Mumbai Vapi",
    "description": "Safe Cab Mumbai Vapi emphasizes passenger safety with sanitized vehicles, GPS-enabled tracking, verified drivers, and responsible highway driving. It is a trusted choice for families, senior citizens, women travelers, and individuals seeking secure and dependable long-distance transportation."
  },
  {
    "name": "Family Cab Mumbai Vapi",
    "description": "Family Cab Mumbai Vapi offers spacious seating, child-friendly comfort, luggage accommodation, and smooth driving for a relaxed family trip. Perfect for vacations, weekend getaways, and family visits, the service ensures an enjoyable and comfortable travel experience for passengers of all ages."
  },
  {
    "name": "Express Highway Cab Vapi",
    "description": "Express Highway Cab Vapi offers fast and smooth highway travel between Mumbai and Vapi, using expert drivers familiar with expressway shortcuts and traffic-free routes. This service ensures minimized travel time, enhanced comfort, and a seamless long-distance cab experience."
  },
  {
    "name": "Mumbai Vapi Pickup Drop",
    "description": "Mumbai Vapi Pickup Drop service provides simple, point-to-point transportation from any location in Mumbai to Vapi. Ideal for hotel guests, business travelers, and families, it features flexible pickup timings, clean cars, and hassle-free door-to-door travel."
  },
  {
    "name": "Mumbai to Silvassa Cab",
    "description": "Mumbai to Silvassa Cab offers reliable transport to the scenic and culturally rich town of Silvassa, located near Vapi. It is perfect for family outings, wildlife park visits, weekend retreats, and business travel. With experienced drivers and comfortable cars, the service ensures a smooth journey to Silvassa’s resorts, hotels, and tourist attractions."
  }
],

"tableData": [
  ["Mumbai Vapi Taxi", "Vapi Cab from Mumbai"],
  ["One-Way Cab Mumbai Vapi", "Affordable Cab Mumbai Vapi"],
  ["Best Taxi Mumbai Vapi", "SUV Cab Mumbai Vapi"],
  ["Sedan Cab Mumbai Vapi", "Outstation Cab Mumbai Vapi"],
  ["24×7 Mumbai Vapi Taxi", "Corporate Cab Mumbai Vapi"],
  ["Fast Cab Mumbai Vapi", "Premium Cab Mumbai Vapi"],
  ["Safe Cab Mumbai Vapi", "Family Cab Mumbai Vapi"],
  ["Express Highway Cab Vapi", "Mumbai Vapi Pickup Drop"],
  ["Mumbai to Silvassa Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Vapi Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Vapi cab services, perfect for business travel, family trips, and smooth intercity journeys to Gujarat."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly maintained cabs to enjoy a comfortable and relaxing ride to Vapi."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Highway Routes",
    "WhyChoosedescription": "Our skilled drivers have excellent knowledge of the Mumbai to Vapi route, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Vapi cab trip worry-free and affordable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Intercity Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental options tailored to your Mumbai to Vapi travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All our cabs are thoroughly cleaned and sanitized before every journey to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your Mumbai to Vapi journey comfortable, easy, and stress-free."
  }
]




























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Vapi cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Vapi cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Vapi cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Vapi cab bookings?',
    answer: 'Shambhu Cabs offers a fleet of well-maintained sedans, SUVs, and premium cars suitable for a smooth and hassle-free journey from Mumbai to Vapi.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Vapi route?',
    answer: 'Yes, our drivers are licensed, trained, and familiar with the Mumbai to Vapi route, ensuring a safe and pleasant travel experience.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Vapi cab?',
    answer: 'Absolutely. You can choose your preferred pickup point in Mumbai and any drop-off location in Vapi.',
  },
  {
    question: 'Is the Mumbai to Vapi cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Vapi cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Vapi cab bookings?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict hygiene and safety protocols throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Vapi cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and offer corporate account billing as well.',
  },
  {
    question: 'Is customer support available during the Mumbai to Vapi journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Vapi travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Patel',
    feedback: 'Our Mumbai to Vapi cab journey with Shambhu Cabs was smooth and comfortable. The driver was polite and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nisha Solanki',
    feedback: 'Very reliable Mumbai to Vapi cab service. Clean car and excellent travel experience. Highly recommend Shambhu Cabs!',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vapi Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-vapi-cab.jpg",
  "description": "Shambhu Cabs provides safe and reliable Mumbai to Vapi cab services for one-way and round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, and long-distance journeys. Enjoy 24×7 service, affordable fares, express highway options, and convenient pickup-drop including Mumbai to Silvassa.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-vapi-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Vapi Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Vapi cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way and round trips, family travel, corporate travel, and long-distance journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop to Silvassa."
  />

  <meta
    name="keywords"
    content="Mumbai Vapi Taxi, Vapi Cab from Mumbai, One-Way Cab Mumbai Vapi, Affordable Cab Mumbai Vapi, Best Taxi Mumbai Vapi, SUV Cab Mumbai Vapi, Sedan Cab Mumbai Vapi, Outstation Cab Mumbai Vapi, 24×7 Mumbai Vapi Taxi, Corporate Cab Mumbai Vapi, Fast Cab Mumbai Vapi, Premium Cab Mumbai Vapi, Safe Cab Mumbai Vapi, Family Cab Mumbai Vapi, Express Highway Cab Vapi, Mumbai Vapi Pickup Drop, Mumbai to Silvassa Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitovapicab;